import { Download, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useDownloadFile } from '@/lib/download-document-file';

type PurchaseOrderDocumentDownloadButtonProps = {
  clientUrl: string;
  fileName: string;
};

export function PurchaseOrderDocumentDownloadButton({
  clientUrl,
  fileName,
}: PurchaseOrderDocumentDownloadButtonProps) {
  const { t } = useTranslation('purchaseOrder');
  const { t: tCommon } = useTranslation('common');
  const { handleDownload, isPending } = useDownloadFile({
    clientUrl,
    fileName,
    onError: () => {
      toast.error(tCommon('error'), {
        description: t('documentsTable.downloadError'),
      });
    },
  });

  return (
    <Button
      aria-label={t('documentsTable.downloadFile')}
      className='shrink-0'
      disabled={isPending}
      onClick={handleDownload}
      size='icon-sm'
      type='button'
      variant='ghost'
    >
      {isPending ? (
        <Loader2 aria-hidden className='size-4 animate-spin' />
      ) : (
        <Download aria-hidden className='size-4' />
      )}
    </Button>
  );
}
